var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container imitate-page"},[_c('div',{staticClass:"imitate-home"},[_c('trade-page',{attrs:{"modalType":_vm.modalType}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }